import React from "react";
import { Link as GatsbyLink } from "gatsby";
import { ensureTrailingSlashHref } from "../../utils/url";

const TrailingSlashLink = ({ to, ...rest }) => (
  <GatsbyLink to={ensureTrailingSlashHref(to)} {...rest} />
);

export default TrailingSlashLink;
